import React from "react";
import { PageHeader } from "../components/common";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Input } from "../components/ui/input";
import { Switch } from "../components/ui/switch";
import { useTheme } from "next-themes";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Settings() {
  const { user } = useAuth();
  const { theme, setTheme } = useTheme();
  return (
    <>
      <PageHeader title="Settings" description="Company profile, appearance, and integration keys." />
      <div className="grid gap-4 md:grid-cols-2">
        <Card className="p-6 rounded-xl">
          <h3 className="font-heading font-medium mb-3">Company profile</h3>
          <div className="space-y-3">
            <div className="space-y-1"><Label>Platform Name</Label><Input defaultValue="RushGro PBaaS" /></div>
            <div className="space-y-1"><Label>Support Email</Label><Input defaultValue="support@rushgro.com" /></div>
            <div className="space-y-1"><Label>Default GST (%)</Label><Input type="number" defaultValue={18} /></div>
            <Button className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="settings-save-btn" onClick={() => toast.success("Settings saved")}>Save changes</Button>
          </div>
        </Card>

        <Card className="p-6 rounded-xl">
          <h3 className="font-heading font-medium mb-3">Appearance</h3>
          <div className="flex items-center justify-between py-2">
            <div>
              <div className="text-sm font-medium">Dark mode</div>
              <div className="text-xs text-muted-foreground">High-contrast night theme for control rooms.</div>
            </div>
            <Switch checked={theme === "dark"} onCheckedChange={(v) => setTheme(v ? "dark" : "light")} data-testid="settings-dark-switch" />
          </div>
        </Card>

        <Card className="p-6 rounded-xl">
          <h3 className="font-heading font-medium mb-3">Integrations</h3>
          <div className="space-y-3">
            <div className="space-y-1"><Label>PhonePe Merchant ID</Label><Input placeholder="PGTESTPAYUAT" /></div>
            <div className="space-y-1"><Label>PhonePe Salt Key</Label><Input placeholder="•••••••••••••" type="password" /></div>
            <div className="text-xs text-muted-foreground">Payments are stubbed until credentials are provided. Invoices can still be marked paid manually.</div>
          </div>
        </Card>

        <Card className="p-6 rounded-xl">
          <h3 className="font-heading font-medium mb-3">Account</h3>
          <div className="space-y-1 text-sm">
            <div className="flex justify-between"><span className="text-muted-foreground">Name</span><span>{user.name}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Email</span><span>{user.email}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Role</span><span className="capitalize">{user.role.replace(/_/g, " ")}</span></div>
          </div>
        </Card>
      </div>
    </>
  );
}
